export const DESTINATION = 'destination';
export const MEETINGS_DESTINATION = 'meetingsDestination';
export const SELECTED_TAB = 'selectedTab';
export const TABBED_SEARCHFORM_CONTAINER = 'tabbedSearchFormContainer';
export const ROOMS_AND_GUESTS = 'roomsAndGuests';
export const DATES = 'dates';
export const MEETINGS_DATES = 'eventsDates';
export const SPECIAL_RATES = 'specialRates';
export const USE_POINTS = 'usePoints';
export const BRANDS = 'brands';
export const RESET = 'reset';
export const DESTINATION_HIDDEN_FIELDS = 'destinationHiddenFields';
export const EVENTS_DESTINATION_HIDDEN_FIELDS = 'meetingsDestinationHiddenFields';
export const LATITUDE_AND_LONGITUDE = 'latitudeAndLongitude';
export const FOCUS_INTERACTIONS = 'focusInteractions';
export const childAgeRequired = 'Child {x}: Age (Required)';
export const maxGuestPerRoom = '8';
export const MILESTOMETERS = 1609.344;
export const RESORTS_HIDDEN_FIELDS = 'resortsHiddenFields';
export const CORP = 'corp';
export const ALERT_BANNER_H = 16;
export const GUEST_ROOMS = 'guestRooms';
export const EVENT_SPACE = 'eventSpace';
export const EVENT_PURPOSE = 'eventPurpose';
export const UNIT_OF_ROOM = 'unitOfRoom';
export const ERROR_MESSAGE = 'errorMessage';
export const EVENTS_ERROR_MESSAGE = 'meetingsErrorMessage';
export const ROOMS_AND_GUESTS_INC_CLICK_TRACK = 'Search form | Room and Guest';
export const ROOMS_AND_GUESTS_CLICK_TRACK = 'Room and Guest reset button | internal';
export const SPECIAL_RATES_DONE_CLICK_TRACK = 'Special Rates done button | internal';
export const NG_SPECIAL_RATES_DONE_CLICK_TRACK = 'CORP code apply button | internal';
export const SPECIAL_RATES_CLOSE_CLICK_TRACK = 'CORP code clear button | internal';
export const SPECIFIC_DATES = 'Specific Dates';
export const FLEXIBLE_DATES = 'Flexible Dates';
export const ROOMS_CLICK_TRACK = 'Rooms';
export const ADULTS_CLICK_TRACK = 'Adults';
export const CHILD_CLICK_TRACK = 'Children';
export const CHILD_AGE_CLICK_TRACK = 'Children age';
export const DEFAULT_CLUSTER_CODE = 'none';
export const GROUP_CODE_LENGTH = 10;
export const GROUP_CODE_MIN_LENGTH = 3;
export const SPECIAL_RATES_CODE_LENGTH = 9;
export const SPECIAL_RATES_CODE_MIN_LENGTH = 2;
export const MAP_VIEW_SESSION_KEY = 'map_view' as const;
export const IS_SHOP_STORE_INITIALIZED = 'isShopStoreInitialized';

// Popup IDs for activePopup state management
export const POPUP_ID_DATEPICKER = 'datepicker';
export const POPUP_ID_ROOMS_AND_GUESTS = 'roomsAndGuests';
export const POPUP_ID_SEARCH_FIELD = 'searchField';
export const POPUP_ID_SPECIAL_RATES = 'specialRates';
